<template>
<div class="col-12 col-md-12 col-lg-6 col-xl-4 py-2">
   <div class="card-wrapper card-space">
      <div class="card card-bg no-after">       
         <div class="card-header bg-primary text-white font-weight-bold">

            <router-link :to="{name: 'subcategory', params: {slug: data.slug, id: data.id, area:data.area, title: data.titolo } }" v-if="!this.$props.data.destUrl && (data.area && data.area != 'articolo')">
               <a class="text-white" v-if="$slots.header">
                  <slot name="header"></slot>
               </a>  
            </router-link>
            <!--router-link :to="{name: 'articolo-programma', params: {slug: data.slug, id: data.id, area:data.area, title: data.titolo } }" v-if="!this.$props.data.destUrl && data.area == 'articolo'">
               <a class="text-white" v-if="$slots.header">
                  <slot name="header"></slot> 2
               </a>  
            </router-link-->

            <router-link :to="link" v-if="this.$props.data.destUrl || data.area == 'articolo'">
               <a class="text-white" v-if="$slots.header">
                  <slot name="header"></slot>
               </a>  
            </router-link>
            
         </div>

         <div class="card-body" :class="bodyClasses" v-if="!noBody">
            <p class="card-text">
               <slot></slot>
            </p>
         </div>         

         <div class="it-card-footer" v-if="!noFooter">
            <div class="separator">            
               <router-link :to="{name: 'subcategory', params: {slug: data.slug, id: data.id, area:data.area, title: data.titolo } }" v-if="data.area">
                  <a class="read-more" v-if="$slots.header">
                     <span class="text">Leggi di più</span>
                     <svg class="icon">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/immagini/61_240_20210329130756.svg#it-arrow-right"></use>
                     </svg>
                  </a>  
               </router-link>

               <!-- router-link :to="{name: 'articolo-programma', params: {_slug: data.slug, id: data.id, area:data.area, title: data.titolo } }" v-if="!data.area">
                  <a class="read-more" v-if="$slots.header">
                     <span class="text">Leggi di più</span>
                     <svg class="icon">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/immagini/61_240_20210329130756.svg#it-arrow-right"></use>
                     </svg>
                  </a>  
               </router-link-->
            </div>
         </div>    
      </div>
   </div>
</div>
</template>
<script>
//import argument from "@/components/Arguments";

export default {
   name: "cardarea",
   components:{
      //argument
   },
   props: {
      id: {
        type: String,
        required: true,
        description: "Card type"
      },  
      data: {
        type: Object,
        description: "News item object"
      },  
      slug: {
        type: Object,
        description: "News item object"
      },
      _slug: {
        type: Object,
        description: "News item object"
      },
      path: {
        type: String,
        description: "New path"
      },
      noBody: {
        type: Boolean,
        default: false,
        description: "Whether card should have wrapper body class"
      },
      noFooter: {
        type: Boolean,
        default: false,
        description: "Whether card should have a footer"
      },    
      bodyClasses: {
        type: [String, Object, Array],
        description: "Card body css classes"
      }

   },
   computed:{      
      link: function () {         

         if(this.$props.data.destUrl){
            return this.$props.data.destUrl;
         }
         else{
            if(this.$props.path !== undefined && this.$props.path !== ''){               
               return this.$props.path + '/' + this.$props.data.slug;
            }
            else{
               return this.$route.path + '/' + this.$props.data.slug;
            }
         }
      }
   }
};
</script>
<style>
</style>
